// extracted by mini-css-extract-plugin
export var bottomwrapper = "Footer-module--bottomwrapper--46546";
export var cookiebutton = "Footer-module--cookiebutton--bf77e";
export var footerbottom = "Footer-module--footerbottom--682db";
export var footercomponent = "Footer-module--footercomponent--286cb";
export var footertop = "Footer-module--footertop--61432";
export var footertopcustom = "Footer-module--footertopcustom--b4a45 Footer-module--footertop--61432";
export var footerwrapper = "Footer-module--footerwrapper--93f7d";
export var fundraiseregswrapper = "Footer-module--fundraiseregswrapper--395a8";
export var legalwrapper = "Footer-module--legalwrapper--71b13";
export var legalwrapperheader = "Footer-module--legalwrapperheader--26e2e";
export var legalwrapperp = "Footer-module--legalwrapperp--446a2";
export var link = "Footer-module--link--fc375";
export var links = "Footer-module--links--60f64";
export var newsletterwrapper = "Footer-module--newsletterwrapper--e20ae";
export var sectionbreakbottom = "Footer-module--sectionbreakbottom--c1db3";
export var sectionbreakmiddle = "Footer-module--sectionbreakmiddle--041d6";
export var sectionbreaktop = "Footer-module--sectionbreaktop--4f609";
export var socialmediawrapper = "Footer-module--socialmediawrapper--61470";
export var usefullinkstitle = "Footer-module--usefullinkstitle--35ecd";
export var usefullinkswrapper = "Footer-module--usefullinkswrapper--0d699";